import generateWithAsyncActions from 'epic-alt-utils';
import alt from 'epic-fortnite-react/alt';

export default generateWithAsyncActions(alt, [
  'getIslands',
  'getIslandsForUser',
  'setIslands',
  'addFavorites',
  'addToPlaylist',
  'checkPlaylist',
  'removeFromPlaylist',
  'setIsland',
  'resetError',
]);
